import React, { useEffect } from 'react';
import { SideBar, Main } from './components';
import { useSearchParams } from 'react-router-dom';
import { capitalize } from '@utils/utils.astro';
import { useAuth } from '@hooks/useAuth';
import { LoaderContext } from '../../App';
import { useUserStore } from '../../models';
import { useTradeHistory } from '../../hooks/useTrade';

const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [mainView, setMainView] = React.useState('Dashboard');

  const dashboardList = [
    { title: 'profile', icon: '/dashboard/profile.svg' },
    { title: 'dashboard', icon: '/dashboard/dashboard.svg' },
    { title: 'trading', icon: '/dashboard/trading.svg' },
    { title: 'wallet', icon: '/dashboard/wallet.svg' },
    { title: 'watchlist', icon: '/dashboard/watchlist.svg' },
    // { title: "profile", icon: "/dashboard/profile.svg" },
  ];

  const { loading } = useAuth();
  const { user } = useUserStore();
  const [isUpdatedTransactions, setIsUpdatedTransactions] =
    React.useState(false);
  const { getTrade } = useTradeHistory();

  const [drawer, setDrawer] = React.useState(
    window.innerWidth <= 900 ? false : true,
  );

  React.useEffect(() => {
    if (user && !isUpdatedTransactions) {
      setIsUpdatedTransactions(true);
      getTrade(user?._id);
    }
  }, [user]);

  const close = () => {
    window.innerWidth <= 900 && setDrawer(false);
  };

  useEffect(() => {
    const view = searchParams.get('view');
    if (view) {
      setMainView(view);
    }
    document.title = `ProWebTrade - ${view ? capitalize(view) : 'Dashboard'}`;
  }, [searchParams]);

  useEffect(() => {
    if (!loading && !user) {
      window.location.href = '/auth/signin';
    }
  }, [user]);

  if (loading) {
    return <div></div>
  }

  if (!user) {
    return <div></div>
  }

  return (
    <section className="dashboard_screen_container">
      <SideBar
        dashboardList={dashboardList}
        setMainView={setMainView}
        setSearchParams={setSearchParams}
        mainView={mainView}
        drawer={drawer}
        close={close}
      />
      <Main mainView={mainView} drawer={drawer} setDrawer={setDrawer} />
    </section>
  );
};

export default Dashboard;
